import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

const Footer = ({ auth: { user } }) => {


	return (
		<div class="footer wf-section">
			<div class="container">
				<div class="w100">
					<p class="center footer footer-mobile">NoiConVoi è un progetto di Fondazione Danesino ETS – Codice Fiscale 96083720183
						{user && user.ruolo == 'admin' ? <> - <a href="/changelog" class="link white">changelog</a>
						</> 
						:
						<> - <a href={`https://www.fondazionedanesino.it/donazioni/`} className="button w-button button-dona" target="_blank">Dona</a></>
						}
					</p>
				</div>
			</div>
		</div>
	)
}

Footer.propTypes = {
	auth: PropTypes.object.isRequired
}

const mapStateToProps = state => ({
	auth: state.auth
});

export default connect(mapStateToProps, {})(Footer);

